import React from 'react';

interface ITFixesCardProps {
  fixes: string[];
  maxItems?: number;
}

const ITFixesCard: React.FC<ITFixesCardProps> = ({ fixes, maxItems = 2 }) => {
  if (!fixes || fixes.length === 0) {
    return (
      <div className="bg-emerald-50/30 border border-emerald-100/50 p-4 rounded-xl">
        <h4 className="text-[10px] font-black text-emerald-600 uppercase tracking-widest mb-2">IT Fixes</h4>
        <p className="text-[11px] text-emerald-900 font-bold italic">No fixes suggested</p>
      </div>
    );
  }

  return (
    <div className="bg-emerald-50/30 border border-emerald-100/50 p-4 rounded-xl">
      <h4 className="text-[10px] font-black text-emerald-600 uppercase tracking-widest mb-2">IT Fixes</h4>
      <ul className="space-y-1.5">
        {fixes.slice(0, maxItems).map((fix, i) => (
          <li key={i} className="text-[11px] text-emerald-900 font-bold leading-tight flex gap-1.5">
            <span className="text-emerald-400 shrink-0">✓</span>
            <span>{fix}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ITFixesCard;
